import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Setvalues } from '../../../../../core/entities/setvalues.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsSetvaluesComponent } from './dialogs-setvalues/edit-dialogs-setvalues/edit-dialogs-setvalues.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-setvalues',
  templateUrl: './setvalues.component.html',
  styleUrls: ['./setvalues.component.scss']
})
export class SetvaluesComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  setvalues: Setvalues = new Setvalues();

  mensajeError: boolean = false;

  constructor(
    public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllSetvalues();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla setvalues
  */
  private getAllSetvalues(): void {
    this.loading = true;
    this.internalHomeService.allSetvalues().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear setvalue
  * @param parametro Opcional. Setvalue vacio.
  */
  public createSetvalue(setvalues?: Setvalues) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = false;
    setvalues = this.setvalues;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsSetvaluesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { setvalues, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllSetvalues();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un setvalue
  * @param parametro Opcional. Setvalue a editar.
  */
  public editSetvalue(setvalues?: Setvalues) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsSetvaluesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { setvalues, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Setvalues) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllSetvalues();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un setvalue
  * @param dato Setvalue a eliminar
  */
  public removeSetvalue(setvalues?: Setvalues) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_setvalues') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeSetvalues(setvalues).subscribe(res => {
            console.log(res);
            this.getAllSetvalues();
            this.loading = true;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
